'use strict';

import template from './repo-gam.html';
import controller from './repo-gam.controller';

const ReporteGamComponent = {
    template,
    controller
};

export default ReporteGamComponent;



// WEBPACK FOOTER //
// ./src/app/components/reportes/reportesGam/repo-gam.component.js